export default {"src":"/_next/static/media/spf-leaf-logo.98ea12d9.svg","height":80,"width":80};